import Service from '@/helpers/service'

export default {

    get(page, params) {
        return Service().get('EquipmentCode?page=' + page, {params});
    }, 
    getByCompany(page, params) {
        return Service().get('EquipmentCode/get-by-company?page=' + page, {params});
    }, 
    getByCompany2(params) {
        return Service().get('EquipmentCode/get-by-company2', {params});
    }, 
    show(id) {
        return Service().get('EquipmentCode/show/'+id);
    },    
    create(params) {
        return Service().post('EquipmentCode/create', params);
    },
    update(id, params) {
        return Service().post('EquipmentCode/update/'+id, params);
    },
    delete(id) {
        return Service().post('EquipmentCode/delete/'+id);
    },
}